import { render, staticRenderFns } from "./updatePasswordSuccess.vue?vue&type=template&id=f3b7d702&"
import script from "./updatePasswordSuccess.vue?vue&type=script&lang=ts&"
export * from "./updatePasswordSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./updatePasswordSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports